import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

export const IconCheck = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "none", ...props }, ref) => {
    const currentStroke = isNumber(stroke) ? `${stroke}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="currentColor"
        stroke={currentStroke}
        {...props}
        ref={ref as any}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.8332 15.079L18.0116 7.90063L19.5437 9.4327L11.5992 17.3771C11.3961 17.5803 11.1205 17.6944 10.8332 17.6944C10.5459 17.6944 10.2703 17.5803 10.0672 17.3771L6.45605 13.766L7.98812 12.234L10.8332 15.079Z"
        />
      </svg>
    );
  }
);
